import { LoginPage, useAuth } from 'shared-ui';
import { useLocation } from 'react-router';
import { useEffect } from 'react';

import { AppRoute } from 'routing/AppRoute.enum';
import { AppName } from 'ui/appName/AppName';
import { useUpdatePasswordModal } from 'hooks/useUpdatePasswordModal/useUpdatePasswordModal';

export const LoginContainer = () => {
  const location = useLocation();
  const { isFreshLogin } = useAuth();
  const { handleUpdatePasswordModalOpen } = useUpdatePasswordModal();

  useEffect(() => {
    handleUpdatePasswordModalOpen(false);
  }, []);

  return (
    <LoginPage
      loginUrl={AppRoute.login}
      redirectUrl={isFreshLogin || !location.state ? AppRoute.cards : location.state.destinationLink}
      appName={<AppName />}
    />
  );
};
